export default __webpack_public_path__ + "static/media/analisism.6e1166d4.png";